import { createStore } from 'vuex'
import cookie from '@/helpers/cookie';

const url = new URL(window.location);
const entry = url.searchParams.get('page');

function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

let defaultState = {
  debug: false, // global variable that can be used to show or hide debuging information
  alerts: {}, // temporary, won't ever need to be saved to API
  rootUrl: window.mockuptoolSettings.root,
  currentlyEditing: [],
  currentView: 'structure', // 'structure' or 'content' view are available
  showWireframes: true,
  imgDebug: false, // global variable which can be used to show additional info for graphics department
  entryId: entry,
  formData: {},
  content: {},
  messages: {},
  waiting: false,
  connectingDrag: false,
  saveAllCounter: 0,
  printToPdfInProgress: false,
},
mockupToolCookieCurrentlyEditing = cookie.get('mockupToolCookieCurrentlyEditing' + entry),
mockupToolCookieCurrentView = cookie.get('mockupToolCookieCurrentView'),
mockupToolCookieShowWireframes = cookie.get('mockupToolCookieShowWireframes');

if (mockupToolCookieCurrentlyEditing) {
  defaultState.currentlyEditing = mockupToolCookieCurrentlyEditing.split(',');
}

if (mockupToolCookieCurrentView) {
  defaultState.currentView = mockupToolCookieCurrentView;

  // use saved values BUT don't show content view if there's nothing to edit
  if (typeof defaultState.currentlyEditing !== 'undefined' && defaultState.currentlyEditing.length === 0) {
    defaultState.currentView = 'structure';
  }
}

if (mockupToolCookieShowWireframes) {
  defaultState.showWireframes = mockupToolCookieShowWireframes === 'true';
}

export default createStore({
  state: defaultState,
  mutations: {
    creatingPdf(state, payload) {
      state.printToPdfInProgress = payload;
    },
    showAlert(state, {text, type, display}) {
      let alert = {},
          id = 'alert' + new Date().getTime(),
          myText, myType, myDisplay;

      myText = text;
      myType = type;
      myDisplay = display;

      alert.text = myText;
      alert.type = myType;
      alert.display = myDisplay;

      state.alerts[id] = alert;
    },
    dismissAlert(state, id) {
      delete state.alerts[id];
    },
    startEditing(state,id) {
      if (!state.currentlyEditing.includes(id)) {
        state.currentlyEditing.push(id);

        cookie.set('mockupToolCookieCurrentlyEditing' + entry, state.currentlyEditing, 7);
      }
      if (state.currentView !== 'content') {
        state.currentView = 'content';

        cookie.set('mockupToolCookieCurrentView', state.currentView, 7);
      }
    },
    stopEditing(state, id) {
      state.currentlyEditing = state.currentlyEditing.filter(i => i !== id);
      if (state.currentlyEditing.length === 0) {
        this.commit('switchToStructureView');
      }

      cookie.set('mockupToolCookieCurrentlyEditing' + entry, state.currentlyEditing, 7);
    },
    hideWireframes(state) {
      state.showWireframes = false;

      cookie.set('mockupToolCookieShowWireframes', state.showWireframes, 7);
    },
    showWireframes(state) {
      state.showWireframes = true;

      cookie.set('mockupToolCookieShowWireframes', state.showWireframes, 7);
    },
    switchToContentView(state) {
      state.currentView = 'content';

      cookie.set('mockupToolCookieCurrentView', state.currentView, 7);
    },
    switchToStructureView(state) {
      state.currentView = 'structure';

      cookie.set('mockupToolCookieCurrentView', state.currentView, 7);
    },
    setEntryId(state, payload) {
      state.entryId = payload;
    },
    updateFormData(state, payload) {
      state.formData = payload
    },
    updateFormField(state, payload) {
      state.formData[payload.id] = payload.content;
    },
    updateParentalFormField(state, payload) {
      let currentContent = state.content[payload.parentalId].content || {};
      let formContent = state.formData[payload.parentalId] || {};
      let newContent = {};
      let finalContent = {};

      newContent[payload.identifier] = payload.content;

      if (currentContent && typeof currentContent === 'string' && currentContent.length > 0 && isJson(currentContent)) {
        currentContent = JSON.parse(currentContent);
      }

      if (formContent && typeof formContent === 'string' && formContent.length > 0 && isJson(formContent)) {
        formContent = JSON.parse(formContent);
      }

      finalContent = {
        ...currentContent,
        ...formContent,
        ...newContent
      };

      state.formData[payload.parentalId] = JSON.stringify(finalContent);
    },
    removeFormField(state, id) {
      delete state.formData[id];
    },
    updateContent(state, payload) {
      state.content[payload.id] = {
        content: payload.content,
        identifier: payload.identifier,
        type: payload.type,
      };
    },
    updateMessages(state, payload) {
      // reset messages before showing new ones
      state.messages = {};
      state.messages[payload.id] = payload.content;
    },
    activateWaiting(state) {
      state.waiting = true;
    },
    deactivateWaiting(state) {
      state.waiting = false
    },
    startConnectingDrag(state) {
      state.connectingDrag = true
    },
    endConnectingDrag(state) {
      state.connectingDrag = false
    },
    triggerSaveAll(state) {
      state.saveAllCounter = state.saveAllCounter+1;
    }
  },
  actions: {
  },
  modules: {
  }
})
